export default __webpack_public_path__ + "static/media/mobile.dd5579e1.svg";